import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toNumber'
})
export class ToNumberPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let reNumber = Number(value);
    return isNaN(reNumber) ? 0 : reNumber;
  }

}
